import { render, staticRenderFns } from "./RechangeReturn.vue?vue&type=template&id=ed75e948&"
import script from "./RechangeReturn.vue?vue&type=script&lang=js&"
export * from "./RechangeReturn.vue?vue&type=script&lang=js&"
import style0 from "./RechangeReturn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports